var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-end gap-2"},[_c('a-button',{staticStyle:{"border-radius":"3px !important"},attrs:{"type":"primary"},on:{"click":_vm.downloadPdf}},[_vm._v("Download Pdf")]),_c('a-button',{staticStyle:{"border-radius":"3px !important"},attrs:{"type":"primary","ghost":""},on:{"click":_vm.closeReport}},[_vm._v("Close")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }